import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, inr } from "@/lib/api";

const Pct = ({ v }) => (
  <span className={v > 0 ? "text-emerald-600" : v < 0 ? "text-rose-600" : "text-slate-500"}>{v > 0 ? "▲" : v < 0 ? "▼" : "•"} {v > 0 ? "+" : ""}{v}%</span>
);
const Tag = ({ children }) => <span className="text-slate-400 font-semibold tracking-widest text-[9.5px]">{children}</span>;

function Items({ t }) {
  const sym = (r, extra) => (
    <span key={r.symbol + (extra || "")} className="inline-flex items-center gap-1.5">
      <span className="text-slate-700 font-medium">{r.symbol}</span>
      {r.ltp != null && <span className="text-slate-400">{inr(r.ltp)}</span>}
      <Pct v={r.change_pct} />{extra}
    </span>
  );
  return (
    <span className="inline-flex items-center gap-6 pr-6">
      {t.indices.map((r) => sym(r))}
      <Tag>TOP GAINERS</Tag>{t.gainers.map((r) => sym(r))}
      <Tag>TOP LOSERS</Tag>{t.losers.map((r) => sym(r))}
      <Tag>SECTORS</Tag>{t.sectors.map((s) => (
        <span key={s.sector} className="inline-flex gap-1.5"><span className="text-slate-700">{s.sector}</span><Pct v={s.perf} /></span>
      ))}
      {t.big_money.length > 0 && <><Tag>BIG MONEY VOLUME</Tag>{t.big_money.map((r) => sym(r, r.rvol ? <span className="text-amber-600">{r.rvol}×</span> : null))}</>}
    </span>
  );
}

export const Ticker = () => {
  const [t, setT] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    const load = () => api.get("/today/ticker").then((r) => setT(r.data)).catch(() => {});
    load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, []);
  if (!t) return null;
  return (
    <div className="border-t border-slate-100 bg-white overflow-hidden whitespace-nowrap font-mono text-[10.5px] h-7 flex items-center cursor-pointer opacity-90"
      data-testid="live-ticker" onClick={() => navigate("/app/today")} title="Live market strip · refreshes every minute">
      <div className="marquee-track inline-flex" style={{ animationDuration: "90s" }} data-testid="live-ticker-track">
        <Items t={t} /><Items t={t} />
      </div>
    </div>
  );
};
